$( document ).ready(function() {


	var numSplides = $(".splide__slide").length;
	var isPartnerLogos = $(".partner-logos-block").length;
	var initSplide = true;
	var cloneNum = 0;
		
	if(numSplides == 1){
		if(isPartnerLogos){ $(".partner-logos-block").addClass("center_cards single"); } 
		else { 				$(".card-slider-block").addClass("center_cards single"); }
	} else if(numSplides == 2){
		if(isPartnerLogos){ $(".partner-logos-block").addClass("center_cards"); } 
		else { 				$(".card-slider-block").addClass("center_cards"); }
	} else if (numSplides == 3){
		cloneNum = 3;
	} else if (numSplides > 3){
		cloneNum = 10;	
	}
		
    if ( $('.logos-container').length ) {
        //Specific to the Partner Logos Block
        var logos_splide = new Splide( '.logos-container', {
            type: 'loop',
            autoWidth: true,
            fixedheight: 32,
            perPage: 1,
            perMove: 6,
            padding: { left: 0, right: 40 },
            gap: 70,
            clones: 10,
            pagination: false,
            autoplay: false,
        });
        logos_splide.mount();
    }

    if ( $('.cards-container').length ) {
        //Specific to the Cards Slider Block
        var cards_splide = new Splide( '.cards-container', {
            type: 'loop',
            fixedheight: 400,
            fixedheight: 400,
            perPage: 2,
            perMove: 1,
            padding: { left: 0, right: 100 },
            gap: 70,
			clones: cloneNum,
            pagination: false,
            autoplay: false,
        });
        cards_splide.mount();
    }
});